// Product tiers as the sidebar sees them. /api/me carries:
//   tier  — what the viewer may use right now (a running trial counts)
//   plan  — what the tenant pays for
//   trial — { tier, until, daysLeft } while a trial of a higher rung runs
// The backend (middleware/reportTierGate.js, requireIntelligence.js) is the
// enforcement; this file only decides what to show and what to label.

export const TIERS = ['basic', 'reports', 'intelligence'];
export const TIER_LABELS = { basic: 'Basic', reports: 'Pro', intelligence: 'Intelligence' };

const rank = (tier) => TIERS.indexOf(tier);

// The lowest tier that includes a nav item (nav.jsx flags).
export const itemTier = (item) => (item.intel ? 'intelligence' : item.basic ? 'basic' : 'reports');

// Badge text for an item the tenant's PAID plan doesn't include — shown while
// a trial lets the viewer use it anyway, and to platform admins looking at a
// lower-tier tenant. Null when the item is part of the plan (no badge).
export function planBadge(item, me) {
  if (!me?.plan) return null;
  const needed = itemTier(item);
  return rank(needed) > rank(me.plan) ? TIER_LABELS[needed] : null;
}

// One line for the trial banner, or null when no trial is running.
export function trialNotice(me) {
  const t = me?.trial;
  if (!t || !t.until) return null;
  const label = TIER_LABELS[t.tier] || t.tier;
  const plan = TIER_LABELS[me.plan] || me.plan;
  const when = new Date(t.until + 'T12:00:00').toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric' });
  const left = t.daysLeft === 0 ? 'today is the last day' : t.daysLeft === 1 ? '1 day left' : `${t.daysLeft} days left`;
  return {
    label,
    plan,
    headline: `${label} trial — ${left}`,
    detail: `Reports marked ${label} are included until ${when}. After that, your ${plan} plan keeps the unmarked reports.`,
  };
}
